import { render } from "./IconoConGuardar.vue?vue&type=template&id=06c15b22&scoped=true"
const script = {}

import "./IconoConGuardar.vue?vue&type=style&index=0&id=06c15b22&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c15b22"]])

export default __exports__